import { Clear, Create, Done } from "@mui/icons-material"
import { Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useState } from "react"
import OneInput from "../../../../../../Components/OneInput/OneInput"
import EdicaoEntrada from "../EdicaoEntrada/EdicaoEntrada"

const CardEntrada = ({ entrada, idCentral }) => {
    const { descricao, id, visivel } = entrada

    const [openEntrada, setOpenEntrada] = useState(false)

    const editEntrada = () => {
        setOpenEntrada(true)
    }

    return (
        <Grid
            xs={12}
            sx={{ alignItems: 'center', paddingTop: '5px' }}
            container
        >
            {openEntrada &&
            <EdicaoEntrada openEntrada={openEntrada} setOpenEntrada={setOpenEntrada} idToEdit={id} idCentral={idCentral} />
            }
            <Grid container xs sx={{ border: '1px solid grey', padding: '10px', borderRadius: '5px', alignItems: 'center' }}>
                <Grid md={10}>
                    <Grid container xs={7} sx={{ alignItems: 'center' }}>
                        <Grid xs={12} md={1.5}>
                            <Typography fontSize="13px" fontWeight='400' >Descrição: </Typography>
                        </Grid>
                        <Grid xs={12} md={10}>
                            <OneInput
                                defaultValue={descricao}
                                readOnly
                                // onChange={handleChange}
                                name={"descricao"}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid md={1.5}>
                    <Grid xs={7} container sx={{ alignItems: 'center' }}>
                        <Grid xs={12} md>
                            {/* <OneSwitch
                                defaultValue={visivel}
                                // onChange={handleChange}
                                name={"visivel"}
                            /> */}
                            {visivel ? (<Done sx={{ color: "green" }}/>) : (<Clear sx={{ color: "red" }}/>)}
                        </Grid>
                        <Grid xs={12} md={9}>
                            <Typography fontSize="13px" fontWeight='400' >Visível </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid md>
                    <Grid xs={1} container sx={{ alignItems: 'center' }}>
                        <Create sx={{ cursor: 'pointer', fontSize: '18px' }} onClick={() => { editEntrada() }}/>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default CardEntrada
